import { render } from "./JoinUsJoiningProcess.vue?vue&type=template&id=078956d0"
const script = {}

import exportComponent from "/home/fluffypony/Projects/tai-g-damn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__